export default __webpack_public_path__ + "static/media/E_Estojo.553702e4.svg";